// The `data-ui-key` of a timeline forecast mark (its hit area and its hover anchor): the mark's
// moment in UTC ISO form. Marks carry the moment as the server sent it, which may name an
// offset (`+02:00`); the telemetry key allowlist has no `+`, and one spelling per moment keeps
// a recorded click and the replay's hover anchor on the same key.

/**
 * @param {string} iso  a mark moment
 * @returns {string}  its `toISOString()` form, or `iso` itself when it does not parse
 */
export function markKey(iso) {
  const ms = Date.parse(iso);
  return Number.isNaN(ms) ? iso : new Date(ms).toISOString();
}
